export const CACHE_KEY_SERVICE_REQUESTS = "ServiceRequests";
export const CACHE_KEY_UNIQUE_FILTER_VALUES: string = "UniqueFilterValues";
export const CACHE_KEY_SERVICE_REQUESTS_PICKLIST = "serviceRequestsPicklist";
